export default {
  SET_USER_DATA: '@YOLA_TEMPLATE_GALLERY/SET_USER_DATA',
  FETCH_USER_PARTNER_DATA: '@YOLA_TEMPLATE_GALLERY/FETCH_USER_PARTNER_DATA',
  FETCH_USER_PREFERENCES: '@YOLA_TEMPLATE_GALLERY/FETCH_USER_PREFERENCES',
  SET_USER_PARTNER_DATA: '@YOLA_TEMPLATE_GALLERY/SET_USER_PARTNER_DATA',
  SET_USER_PREFERENCES: '@YOLA_TEMPLATE_GALLERY/SET_USER_PREFERENCES',
  UPDATE_USER_PREFERENCE: '@YOLA_TEMPLATE_GALLERY/UPDATE_USER_PREFERENCE',
};
